import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import ContentLoader from 'components/common/loaders/ContentLoader';
import moment from 'moment';

export default class MonthCalendar extends Component {
  static propTypes = {
    appointmentList: PropTypes.array.isRequired,
    fetchMonthAppointments: PropTypes.func,
    changeMonthActiveDate: PropTypes.func,
    currentDate: PropTypes.object,
    activeDate: PropTypes.object
  }

  constructor(props) {
    super(props);
    const currentDate = get(props, 'currentDate', null);
    const validDate = currentDate && moment(currentDate).isValid() ? moment(currentDate) : moment();
    this.state = {
      currMonth: validDate.toDate(),
      isLoading: false
    };
  }

  hasAppointments = (date) => {
    const { appointmentList } = this.props;
    if (!Array.isArray(appointmentList)) { return false; }
    const dateStr = moment(date).format('YYYY/MM/DD');
    const appointmentDates = appointmentList.map(appt => moment(appt.startDate).format('YYYY/MM/DD'));
    return appointmentDates.indexOf(dateStr) !== -1;
  }

  handleDateChange = (date) => {
    if (date && this.props.changeMonthActiveDate) {
      const momentDate = moment(date);
      if (momentDate.isValid()) {
        this.props.changeMonthActiveDate(momentDate);
      }
    }
  }

  handleMonthChange = async (date) => {
    if (!date) return;

    this.setState({ isLoading: true, currMonth: date });

    // Clear activeDate when changing months
    if (this.props.changeMonthActiveDate) {
      this.props.changeMonthActiveDate(null);
    }

    const monthMoment = moment(date).startOf('month');
    await this.props.fetchMonthAppointments(monthMoment);

    this.setState({ isLoading: false });
  }

  renderDayContents = (day, date) => {
    const hasAppts = this.hasAppointments(date);
    const indicatorStyle = {
      background: hasAppts ? 'black' : 'none'
    };

    return (
      <div className="custom-day-wrapper">
        <div className="tile-day-circle">
          <span className="tile-day-text">{day}</span>
        </div>
        <div style={indicatorStyle} className="tile-indicator" />
      </div>
    );
  }

  render() {
    // Validate and determine the selected date
    const activeDate = this.props.activeDate && moment(this.props.activeDate).isValid()
      ? this.props.activeDate.toDate()
      : null;

    const currMonth = this.state.currMonth;

    return (
      this.state.isLoading
        ? <ContentLoader isLoading={this.state.isLoading} />
        : <div className="monthview-calendar">
          <DatePicker
            selected={activeDate}
            onChange={this.handleDateChange}
            onMonthChange={this.handleMonthChange}
            inline
            calendarClassName="custom-month-calendar"
            renderDayContents={this.renderDayContents}
            monthsShown={1}
            showMonthYearPicker={false}
            openToDate={currMonth}
          />
        </div>
    );
  }
}
